import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { CookieConsentProvider } from "./context/Cookie/CookieConsentContext";
import CookieConsentBanner from "./components/CookieConsentBanner";
import ScrollToTop from "./components/ScrollToTop";
import "./lang/i18n";
import ContactUs from "./pages/ContactUs";
import PageNotFound from "./pages/PageNotFound";
import PropertyListing from "./pages/PropertyListing";
import PropertyDetail from "./pages/PropertyDetail";
import Career from "./pages/Career";
import Offer from "./pages/Offer";
import Area from "./pages/Area";
import Developer from "./pages/Developer";
import DeveloperProject from "./pages/DeveloperProject";
import News from "./pages/News";
import NewsDetails from "./pages/NewsDetails";
import Freelancers from "./pages/Freelancers";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { SnackbarProvider } from 'notistack';
import ResetScroll from "./helper/ResetScroll";
import Faq from "./pages/Faq";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import Franchise from "./pages/Franchise";
import Map from "./pages/Map";
import { HelmetProvider } from "react-helmet-async";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import NewLaunch from "./pages/NewLaunch";
import GeoRedirect from "./routes/GeoRedirect";
import { fetchAPI } from "./helper/fetchAPI";
import * as constants from "./constants";
import { useCountryPrefix } from "./routes/useCountryPrefix";
import Growth from "./pages/Growth";
import Partner from "./pages/Partner";


function App() {
  // const countryPrefix = useCountryPrefix();
  const { i18n } = useTranslation();
  const language = i18n.language;





  useEffect(() => {


    // Set `lang` and `dir` attributes based on the active language
    document.documentElement.lang = language;
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';


    // Load RTL styles if Arabic
    if (language === 'ar') {
      const rtlStyles = [
        '/assets/css/bootstrap.rtl.min.css?v0.1',
        '/assets/css/style-rtl.css?v0.1',
        '/assets/css/responsive-rtl.css?v0.1'
      ];

      rtlStyles.forEach((href) => {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        document.head.appendChild(link);
      });
    }


    // Cleanup RTL styles when switching languages
    return () => {
      document.querySelectorAll('link[rel="stylesheet"]').forEach((el) => {
        if (el.href.includes('rtl')) {
          el.remove();
        }
      });
    };
  }, [language]);


  // Define all page routes (without duplication)
  const renderRoutes = () => [
    // <Route index element={<Home />} key="home" />,
    <Route path="about-us" element={<AboutUs />} key="about-us" />,
    <Route path="contact" element={<ContactUs />} key="contact" />,
    <Route path="search" element={<PropertyListing />} key="search" />,
    <Route path="careers" element={<Career />} key="career" />,
    <Route path="offer" element={<Offer />} key="offer" />,
    <Route path="area/:cityName" element={<Area />} key="area" />,
    <Route path="launch/:projectName/:idProject" element={<NewLaunch />} key="launch" />,
    <Route path="developers" element={<Developer />} key="developers" />,
    <Route path="developers/:developerName/:idDeveloper" element={<DeveloperProject />} key="devProject1" />,
    <Route path="developers/:cityName/:developerName/:idDeveloper" element={<DeveloperProject />} key="devProject2" />,
    <Route path="developers/:developerName/project/:projectName/:idProject" element={<PropertyListing />} key="devProjListing" />,
    <Route path="developers/:developerName/project/:projectName/property/:idTitle/:idProperty" element={<PropertyDetail />} key="devProjDetail" />,
    <Route path="blogs" element={<News />} key="news" />,
    <Route path="blogs/:idSlug" element={<NewsDetails />} key="newsDetail" />,
    <Route path="growth" element={<Growth />} key="growth" />,
    <Route path="partner" element={<Partner />} key="partner" />,
    <Route path="faq" element={<Faq />} key="faq" />,
    <Route path="privacy-policy" element={<PrivacyPolicy />} key="privacy" />,
    <Route path="terms-conditions" element={<TermsAndConditions />} key="terms" />,
    <Route path="map" element={<Map />} key="map" />,
    <Route path="*" element={<PageNotFound />} key="notfound" />
  ];

  return (
    <>
      <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}>
        <HelmetProvider>

          <SnackbarProvider maxSnack={1} autoHideDuration={2000}>
            <CookieConsentProvider>
              <Router>
                <ResetScroll></ResetScroll>
                <AppContent
                  i18n={i18n}
                  renderRoutes={renderRoutes}
                />

                {/* <div className="App">
                  <Navbar mainMenu={mainMenu} />
                  <GeoRedirect />
                  <Routes>
                    <Route path="/:country/*" >
                      <Route path="" element={<Home />} />
                      {renderRoutes()}
                      <Route path="*" element={<PageNotFound />} />
                    </Route>
                    <Route path="/:country/:lang/*" >
                      <Route path="" element={<Home />} />
                      {renderRoutes()}
                      <Route path="*" element={<PageNotFound />} />
                    </Route>
                  </Routes>

                  <CookieConsentBanner></CookieConsentBanner>
                  <ScrollToTop></ScrollToTop>
                  <Footer mainSection={mainSection}
                    areaSection={areaSection}
                    recommendedSection={recommendedSection}
                    contactSection={contactSection} />
                </div> */}
              </Router>
            </CookieConsentProvider>
          </SnackbarProvider>
        </HelmetProvider>
      </GoogleReCaptchaProvider>
    </>
  );
}

function AppContent({ i18n, renderRoutes }) {
  const countryPrefix = useCountryPrefix(); // ✅ now inside Router context

  const [mainSection, setMainPageSection] = useState();
  const [areaSection, setAreaSection] = useState();
  const [recommendedSection, setRecommendedSection] = useState();
  const [contactSection, setContactSection] = useState();
  const [mainMenu, setMainMenu] = useState();


  useEffect(() => {

    fetchData()
  }, [countryPrefix])

  const fetchData = async () => {


    const isArabic = i18n.language === "ar";
    const language = isArabic ? "ar" : "en";

    let apiUrl = process.env.REACT_APP_API_URL;

    apiUrl = `${apiUrl}${constants.footersection}?language=${language}&region_id=${countryPrefix}`;
    const res = await fetchAPI(apiUrl, "Get");
    if (res?.status === 200) {

      setMainPageSection(res?.data?.footerSections?.mainPageSection)
      setAreaSection(res?.data?.footerSections?.areaSection)
      setRecommendedSection(res?.data?.footerSections?.recommendedSection)
      setContactSection(res?.data?.footerSections?.contactSection)
      setMainMenu(res?.data?.headerSections?.menuSection)
    }
  }


  return (
    <div className="App">
      <Navbar mainMenu={mainMenu} />
      <GeoRedirect />
      <Routes>
        {/* <Route path="/:country/*" element={<Home />} /> */}
        <Route path="/:country/*">
          <Route index element={<Home />} />
          {renderRoutes()}
          <Route path="*" element={<PageNotFound />} />
        </Route>
        {/* Country + Language routes */}
        <Route path="/:country/:lang/*">
          <Route index element={<Home />} />
          {renderRoutes()}
          <Route path="*" element={<PageNotFound />} />
        </Route>
        {/* your other routes */}
      </Routes>
      <CookieConsentBanner />
      <ScrollToTop />
      <Footer
        mainSection={mainSection}
        areaSection={areaSection}
        recommendedSection={recommendedSection}
        contactSection={contactSection}
      />
    </div>
  );
}

export default App;
